const RADIUS = 75;
export const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
